import { logger } from "@platform/browser-logger";
import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

let modulesRegistered = false;
let licenseSet = false;

/**
 * This function registers the AG Grid Enterprise modules and sets the license key.
 * @param licenseKey The AG Grid Enterprise license key
 */
export const registerAgGridModules = (licenseKey: string): void => {
  if (!modulesRegistered) {
    ModuleRegistry.registerModules([AllEnterpriseModule]);
    modulesRegistered = true;
  }

  if (!licenseKey) {
    logger.warn(
      "AG Grid Enterprise license key is not provided. Please set the license key to avoid evaluation warnings.",
    );
    return;
  }

  if (!licenseSet) {
    LicenseManager.setLicenseKey(licenseKey);
    licenseSet = true;
  }
};
